module.exports = __webpack_public_path__ + "media/34.d73f5e09.wav";